import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font,
  global = variables.global;
export var mainTitle = /*#__PURE__*/css("margin:0 0 14px;color:", colour.neutral700, ";font-family:", font.headingFontFamily, ";font-size:20px;font-weight:600;line-height:1.2;text-align:left;");
export var expandClickZone = /*#__PURE__*/css(":before{position:absolute;top:0;bottom:0;left:0;right:0;content:'';z-index:", global.layerOverlay, ";}");